import { useState, useEffect } from 'react'
import { supabase } from '../../lib/supabase'

export default function StudentReports() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetch() {
      const { data: { user } } = await supabase.auth.getUser()
      const { data: acc } = await supabase.from('student_accounts')
        .select('*, students(name, grade, student_code, groups(name, grade_level))').eq('id', user.id).single()
      if (!acc) { setLoading(false); return }
      const sid = acc.student_id
      const [{ data: grades }, { data: att }, { data: hw }] = await Promise.all([
        supabase.from('grades').select('*').eq('student_id', sid),
        supabase.from('attendance').select('*').eq('student_id', sid),
        supabase.from('homework').select('*').eq('student_id', sid),
      ])
      const avgGrade = grades?.length ? Math.round(grades.reduce((a,g)=>a+(g.score/g.total*100),0)/grades.length) : null
      const attPct = att?.length ? Math.round(att.filter(a=>a.status==='present').length/att.length*100) : null
      const hwPct = hw?.length ? Math.round(hw.filter(h=>h.status==='done').length/hw.length*100) : null
      const overall = Math.round(((avgGrade??50)*.5)+((attPct??50)*.3)+((hwPct??50)*.2))
      const gradeLabel = overall>=90?'Excellent':overall>=75?'Very Good':overall>=60?'Good':overall>=50?'Pass':'Needs Improvement'
      const gradeColor = overall>=90?'var(--success)':overall>=75?'#185fa5':overall>=60?'#534ab7':overall>=50?'var(--warning)':'var(--danger)'
      setData({ student: acc.students, avgGrade, attPct, hwPct, overall, gradeLabel, gradeColor, totalExams: grades?.length, grades: grades?.sort((a,b)=>new Date(b.created_at)-new Date(a.created_at)) })
      setLoading(false)
    }
    fetch()
  }, [])

  const pctClass = (p) => p==null?'':p>=80?'badge-success':p>=60?'badge-warning':'badge-danger'

  if (loading) return <div className="empty">Loading...</div>
  if (!data) return <div className="empty">No data available</div>

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:20 }}>
      <h2 style={{ fontSize:20, fontWeight:500 }}>My Report</h2>

      {/* Overall */}
      <div className="card" style={{ textAlign:'center', padding:28 }}>
        <div style={{ fontSize:13, color:'var(--text3)', marginBottom:8 }}>Overall Performance</div>
        <div style={{ fontSize:52, fontWeight:700, color: data.gradeColor }}>{data.overall}%</div>
        <div style={{ fontSize:18, fontWeight:500, color: data.gradeColor, marginTop:4 }}>{data.gradeLabel}</div>
      </div>

      {/* Stats grid */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:12 }}>
        {[
          { label:'Exams Avg',  val: data.avgGrade!=null?data.avgGrade+'%':'—', p: data.avgGrade },
          { label:'Attendance', val: data.attPct!=null?data.attPct+'%':'—',     p: data.attPct   },
          { label:'Homework',   val: data.hwPct!=null?data.hwPct+'%':'—',       p: data.hwPct    },
        ].map(stat => (
          <div key={stat.label} className="card" style={{ textAlign:'center', padding:14 }}>
            <div style={{ fontSize:11, color:'var(--text3)', marginBottom:6, textTransform:'uppercase', letterSpacing:.04 }}>{stat.label}</div>
            <div style={{ fontSize:22, fontWeight:700 }}>
              <span className={`badge ${pctClass(stat.p)}`} style={{ fontSize:16 }}>{stat.val}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Exam history */}
      {data.grades?.length > 0 && (
        <div className="card" style={{ padding:0, overflow:'hidden' }}>
          <div style={{ padding:'12px 16px', borderBottom:'0.5px solid var(--border)', fontWeight:500, fontSize:14 }}>Exam History</div>
          <table>
            <thead><tr><th>Exam</th><th>Score</th><th>%</th></tr></thead>
            <tbody>
              {data.grades.map(g => {
                const p = Math.round(g.score/g.total*100)
                return (
                  <tr key={g.id}>
                    <td style={{ fontWeight:500 }}>{g.exam_name}</td>
                    <td>{g.score}/{g.total}</td>
                    <td><span className={`badge ${pctClass(p)}`}>{p}%</span></td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}